import { ChangeDetectionStrategy, Component, ElementRef, LOCALE_ID, ViewChild, inject, resource } from "@angular/core";
import { NgOptimizedImage } from "@angular/common";
import { Swiper } from "swiper";
import { Pagination } from "swiper/modules";

import { register } from "swiper/element/bundle";
import { afterNextRender } from "@angular/core";
import { AppService } from "../../app.service";
import { ITestimonialForm } from "@in2/models";
import { HtmlPipe } from "@upupa/common";

export type TestimonialViewModel = { text: string; date: Date; author: string; bio: string };

@Component({
    selector: "in2-testimonials-slider",
    imports: [HtmlPipe, NgOptimizedImage],
    templateUrl: "./testimonials.component.html",
    styleUrls: ["./testimonials.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TestimonialsComponent {
    @ViewChild("swiperContainer", { static: false }) swiperContainer: ElementRef | undefined;
    private readonly locale = inject(LOCALE_ID);
    swiper!: Swiper;
    private readonly contentService = inject(AppService);

    testimonialsResource = resource({
        loader: () => {
            return this.contentService.fetchJsonAsset<ITestimonialForm[]>(`/testimonial?lang=${this.locale}&status=published&sort_by=order,asc`).then((res) => {
                return res.data.map((item: ITestimonialForm) => {
                    return {
                        text: item.body,
                        date: item.publishedAt || item.createdAt,
                        author: item.name,
                        position: item.position,
                        bio: item.bio,
                    };
                });
            });
        },
    });

    constructor() {
        afterNextRender(() => {
            register();
            this.initSwiper();
        });
    }

    private async initSwiper() {
        await new Promise((r) => setTimeout(r, 500));
        if (!this.swiperContainer) return;
        if (this.swiper) return this.swiper.update();
        try {
            this.swiper = new Swiper(this.swiperContainer.nativeElement, swiperConfig as any);
        } catch (error) {
            console.error(error);
        }
    }
}

const swiperConfig = {
    modules: [Pagination],
    direction: "horizontal",
    slidesPerView: 1,
    spaceBetween: 24,
    loop: true,
    autoplay: {
        delay: 5000,
    },
    grabCurser: true,
    pagination: {
        el: ".swiper-pagination",
    },
};
